import { gql } from '@/__generated__';

const GET_USER_PREFERENCES_METRICS = gql(`#graphql
  query GetUserPreferencesMetrics($input: UserInput) {
    user(input: $input) {
      id
      preferences {
        id
        metrics {
          id
          fields {
            id
            name
            defaultConfiguration {
              precision
              unit
            }
            additionalConfigurations {
              deviceType
              precision
              unit
            }
          }
        }
        defaultMetrics: metrics(defaultValues: true) {
          id
          fields {
            id
            name
            defaultConfiguration {
              precision
              unit
            }
            additionalConfigurations {
              deviceType
              precision
              unit
            }
          }
        }
      }
    }
  }
`);

export default GET_USER_PREFERENCES_METRICS;
